// 登录相关
const homeRoutes = [
  {
    path: '/',
    name: 'layout',
    component: () => import('@/layout/default.vue'),
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('@/views/index/index.vue'),
        meta: {
          cnName: '首页',
          enName: 'Home'
        }
      },
      {
        path: 'custom-home',
        name: 'custom-home',
        component: () => import('@/views/index/custom-homepage.vue'),
        meta: {
          cnName: '自定义首页',
          enName: 'Home'
        }
      }
    ]
  },
  {
    path: '/en',
    redirect: '/'
  }
]

export default homeRoutes
